const comments = [
  {
    name: '影迷小陈',
    avatar: '陈',
    rating: 5,
    date: '2026-07-29',
    content: '用了91影视看片app快一年了，高清电影在线观看体验真的没话说。之前在其他平台看总会有缓冲，这里几乎秒开，画质也明显更好。特别是蓝光影视资源专区，每部都是精心调校过的片源，在家就能享受影院级观影。推荐给了身边所有爱看电影的朋友！',
  },
  {
    name: '追剧达人Linda',
    avatar: 'L',
    rating: 5,
    date: '2026-07-26',
    content: '作为一个重度追剧用户，91影视看片app的高清电视剧免费频道简直是我的救命稻草。更新速度超快，热门剧集几乎同步上线，而且全部免费高清。超清综艺播放也很给力，周末看综艺再也不模糊了。强烈推荐给所有剧迷和综艺粉！',
  },
  {
    name: '电影发烧友阿杰',
    avatar: '杰',
    rating: 5,
    date: '2026-07-20',
    content: '从1080P到4K蓝光，91影视看片app的画质进化令人惊叹。作为影视高清片源的深度用户，这里的资源丰富程度和分类精准度远超同类平台。不缓冲高清播放技术确实名不虚传，即使用手机流量也能流畅观看。高清影视大全，名副其实！',
  },
  {
    name: '家庭观影用户王先生',
    avatar: '王',
    rating: 4,
    date: '2026-07-16',
    content: '周末一家人用电视投屏看91影视看片app上的电影，蓝光画质清晰得不可思议。老人孩子都能轻松操作，片源覆盖也很全面，从老片到新片一应俱全。如果能有更多家庭亲子类影片就更完美了，但目前的体验已经非常满意。',
  },
  {
    name: '学生党小周',
    avatar: '周',
    rating: 5,
    date: '2026-07-12',
    content: '作为大学生，免费高清看片对我来说太重要了。91影视不仅免费，画质还特别好。在线高清播放体验流畅，宿舍网络条件一般的情况下也能稳定观看。备考期间还发现了很多优质纪录片，学习娱乐两不误，真心推荐给所有学生朋友。',
  },
];

export default function Comments() {
  return (
    <section id="comments" className="py-12 md:py-16 bg-background-100">
      <div className="section-container">
        <h2 className="font-display text-2xl md:text-3xl text-foreground-950 text-center mb-2">用户口碑</h2>
        <p className="text-sm text-foreground-500 text-center mb-8 md:mb-10">来自真实用户的高清观影体验分享</p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {comments.map((item, i) => (
            <div
              key={i}
              className={`bg-background-50 rounded-lg p-4 md:p-5 flex flex-col ${
                i >= 3 ? 'lg:col-span-1 md:col-span-1' : ''
              }`}
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-sm font-bold text-primary-700">{item.avatar}</span>
                </div>
                <div className="min-w-0">
                  <div className="text-sm font-semibold text-foreground-900 whitespace-nowrap">{item.name}</div>
                  <div className="text-xs text-foreground-500 whitespace-nowrap">{item.date}</div>
                </div>
                <div className="ml-auto flex items-center gap-0.5">
                  {Array.from({ length: item.rating }).map((_, j) => (
                    <i key={j} className="ri-star-fill text-xs text-accent-500"></i>
                  ))}
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed flex-1">{item.content}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}